import { Text } from '@wartek-id/text-v1'

import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'

type TitleProps = {
  title?: string
}

const DEFAULT_TITLE = 'Lakukan Penetapan untuk Pegawai Anda'

export function Title({ title = DEFAULT_TITLE }: TitleProps) {
  const items = usePenetapanPredikatTableStore((state) => state.initialItems)

  return (
    <Text as="h3" variant="heading-md" className="shrink-0">
      {title} ({items.length})
    </Text>
  )
}
